@if (hasLoadedBranding) {
  @if (currentUser?.acceptDpa && !sessionData()?.passwordExpired) {
    <app-header></app-header>
  }
  <router-outlet></router-outlet>
  @if (false) { <app-footer></app-footer> }
}
